export const SLOT_TOKEN = Symbol('Icon');
